import { InjectionToken } from '@angular/core';
import { IBaseApiServiceOptions } from '@bds/odata';

export const RAILTRAC_CONFIG = new InjectionToken<railtracConfig>('RAILTRAC_CONFIG');

export interface railtracConfig extends IBaseApiServiceOptions {
    appUrl: string;
    odataUrl: string;
}
